import CarriersReport from "../../features/statistics/UserStats/CarriersReport";
import CurrentMonth from "../../features/statistics/UserStats/CurrentMonth";
import PreviousMonths from "../../features/statistics/UserStats/PreviousMonths";

import UserStatsSkeleton from "../../components/skeletons/UserStatsSkeleton";
import { useGetCurrentUserStatsQuery } from "../../features/statistics/statisticsApiSlice";

const Statistics = () => {
	const { data: stats, error, isLoading } = useGetCurrentUserStatsQuery();

	if (isLoading) {
		return <UserStatsSkeleton />;
	}

	return (
		<>
			<CurrentMonth data={stats.current} />
			<PreviousMonths data={stats.previous} />
			<CarriersReport />
		</>
	);
};

export default Statistics;
